const type = 'SET_CARD_STATUS_CHANGE_OUTCOME';

const setCardStatusChangeOutcome = (data) => ({
  data,
  type,
});

export { type };
export default setCardStatusChangeOutcome;
